import React from "react";
import { NavLink } from "react-router-dom";
import { Project } from "../../../../infrastructure/types/project";
import ImageWrapper from "../../imageWrapper";
import Flex from "../../ui/Flex/Flex";

type SingleProjectProps = {
  project: Project;
};
const SingleProject = ({ project }: SingleProjectProps) => {
  const imageUrl = project.project_hero_image.image.asset.url;
  const altText = project.project_hero_image.image.alt_text;

  return (
    <div
      className="single-project data-section"
      id={project.slug.current}
      data-scroll
      data-scroll-repeat
    >
      <div className="single-project__info-wrapper">
        <div className="single-project__info-content pt-13">
          <Flex column gap={5} alignCenter>
            <div>
              <h3>{project.project_title}</h3>
              <p className="text-title-4">
                {new Date(project.project_date).getFullYear()}
              </p>
            </div>
            <NavLink
              to={"project/" + project.slug.current}
              className="project-link"
            >
              Voir
            </NavLink>
          </Flex>
        </div>
        <ImageWrapper alt={altText} src={imageUrl} />
      </div>
    </div>
  );
};

export default SingleProject;
